import {
  Component,
  ChangeDetectionStrategy,
  Input,
  OnInit,
  OnDestroy
} from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ColDef, GridApi, GridOptions, GridReadyEvent } from 'ag-grid-community';

@Component({
  selector: 'app-detail-cell-renderer',
  templateUrl: './detail-cell-renderer.component.html',
  styleUrls: ['./detail-cell-renderer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DetailCellRendererComponent
  implements ICellRendererAngularComp, OnInit, OnDestroy
{
  // Inputs from ag-Grid params
  public childColumnDefs!: ColDef[];
  public parentData: any;
  public enableAddChildRow = false;
  public addChildRowLabel = 'Add Child Row';
  private onAddChildCallback!: (parent: any) => void;

  // Child grid
  public childGridOptions: GridOptions = {};
  private childGridApi!: GridApi;
  public childRowData: any[] = [];

  // Ag-Grid lifecycle
  agInit(params: any): void {
    this.parentData = params.parentData;
    this.childColumnDefs = params.childColumnDefs || [];
    this.enableAddChildRow = params.enableAddChildRow || false;
    this.addChildRowLabel = params.addChildRowLabel || 'Add Child Row';
    this.onAddChildCallback = params.onAddChild;

    // Set up child grid options
    this.childGridOptions = {
      columnDefs: this.childColumnDefs,
      rowData: [],
      domLayout: 'autoHeight',
      suppressHorizontalScroll: false,
      // Optional: add pagination, sorting etc.
    };

    // Load child data
    this.loadChildData();
  }

  refresh(params: any): boolean {
    // Called when master row data changes – reload child data
    this.parentData = params.parentData;
    this.loadChildData();
    return true;
  }

  onChildGridReady(event: GridReadyEvent): void {
    this.childGridApi = event.api;
    this.childGridApi.setGridOption('rowData', this.childRowData);
  }

  private loadChildData(): void {
    // Support both: direct property (childDataProperty) and async getter (getChildData)
    const prop = (this as any).params?.childDataProperty;
    const getter = (this as any).params?.getChildData;

    if (prop && this.parentData) {
      this.childRowData = this.parentData[prop] || [];
    } else if (getter && typeof getter === 'function') {
      const result = getter(this.parentData);
      if (result instanceof Promise) {
        result.then(data => {
          this.childRowData = data || [];
          if (this.childGridApi) {
            this.childGridApi.setGridOption('rowData', this.childRowData);
          }
        });
      } else {
        this.childRowData = result || [];
      }
    } else {
      this.childRowData = [];
    }

    if (this.childGridApi) {
      this.childGridApi.setGridOption('rowData', this.childRowData);
    }
  }

  onAddChild(): void {
    if (this.onAddChildCallback) {
      this.onAddChildCallback(this.parentData);
    }
  }

  ngOnInit(): void {}
  ngOnDestroy(): void {}
}